{
  "morning": "Dobro jutro",
  "afternoon": "Dobar dan",
  "evening": "Dobra večer",
  "welcome": "Dobrodošli",
  "manageDescription": "Upravljajte svojim računima, pružateljima i plaćanjima ovdje.",
  "quickLinks": "Brzi linkovi",
  "nav": {
    "dashboard": "Početna",
    "invoices": "Računi",
    "addresses": "Adrese",
    "actions": "Akcije",
    "analytics": "Analitika",
    "settings": "Postavke",
    "payment": "Plaćanje",
    "meterReadings": "Očitanja brojila",
    "adminSettings": "Admin Postavke",
    "main": "Glavni",
    "tools": "Alati",
    "admin": "Admin"
  },
  "button": {
    "save": "Sačuvaj",
    "cancel": "Otkaži",
    "delete": "Obriši",
    "edit": "Uredi",
    "submit": "Potvrdi",
    "back": "Nazad",
    "close": "Zatvori",
    "retry": "Pokušaj ponovo",
    "logout": "Odjava"
  },
  "label": {
    "email": "Email",
    "password": "Lozinka",
    "name": "Naziv",
    "status": "Status",
    "provider": "Pružatelj",
    "address": "Adresa",
    "date": "Datum",
    "amount": "Iznos",
    "username": "Korisničko ime",
    "accountKeyword": "Ključna riječ ispred broja računa (IBAN)",
    "skipPayment": "Preskoči plaćanje",
    "taxDeduction": "Porezni odbitak"
  },
  "placeholder": {
    "email": "ti@primjer.com",
    "password": "••••••••",
    "yourName": "Vaše ime",
    "providerName": "Naziv pružatelja",
    "addressName": "Naziv adrese",
    "username": "Korisničko ime",
    "accountKeyword": "npr. Račun:, IBAN:",
    "otpCode": "Unesite OTP kod",
    "passwordNew": "Nova lozinka (ostavite prazno da zadržite)",
    "passwordExisting": "Lozinka",
    "taxDeductionAmount": "Iznos poreznog odbitka (KM)",
    "fromDate": "Od",
    "toDate": "Do"
  },
  "status": {
    "pending": "Na čekanju",
    "processing": "U obradi",
    "paid": "Plaćeno",
    "completed": "Završeno",
    "failed": "Neuspješno",
    "skipped": "Preskočeno"
  },
  "message": {
    "loading": "Učitavanje...",
    "somethingWentWrong": "Došlo je do greške",
    "unexpectedError": "Došlo je do neočekivane greške.",
    "reloadPage": "Ponovo učitaj stranicu",
    "registrationDisabled": "Registracija je onemogućena",
    "noInvoicesFound": "Nema pronađenih računa",
    "noProvidersYet": "Još nema pružatelja",
    "noAddressesYet": "Još nema adresa",
    "pageNotFound": "Stranica nije pronađena",
    "goToDashboard": "Idi na nadzornu ploču"
  },
  "form": {
    "signIn": "Prijava",
    "signingIn": "Prijava u toku...",
    "rememberMe": "Zapamti me",
    "forgotPassword": "Zaboravljena lozinka?",
    "createAccount": "Kreiraj nalog",
    "creatingAccount": "Kreiranje naloga u toku...",
    "save": "Sačuvaj",
    "saving": "Čuvanje u toku...",
    "confirmPay": "Potvrdi & Plati",
    "changeStatus": "Promijeni status",
    "downloadPdf": "Preuzmi PDF",
    "assignProvider": "Dodijeli pružatelja",
    "assign": "Dodijeli",
    "remove": "Ukloni",
    "addAddress": "Dodaj adresu",
    "editAddress": "Uredi adresu",
    "editProvider": "Uredi pružatelja"
  },
  "dashboard": {
    "welcome": "Dobrodošli",
    "manageDescription": "Upravljajte svojim računima, pružateljima i plaćanjima ovdje.",
    "totalInvoices": "Ukupno računa",
    "totalPaid": "Ukupno plaćeno",
    "pendingProcessing": "Na čekanju / U obradi",
    "avgMonthly": "Prosječno mjesečno",
    "quickLinks": "Brzi linkovi"
  },
  "payment": {
    "processing": "Obrada plaćanja",
    "complete": "Plaćanje završeno",
    "history": "Istorija plaćanja",
    "twoFaRequired": "Potrebna je 2FA potvrda",
    "enterOtp": "Unesite OTP kod",
    "progress": "Obrada {{count}} od {{total}} račun(a)...",
    "progressDot": "Obrada {{count}} od {{total}} račun(a)...",
    "cancel": "Otkaži"
  },
  "scraping": {
    "title": "Skupljanje podataka",
    "start": "Pokreni skupljanje",
    "inProgress": "Skupljanje u toku...",
    "clearLogs": "Obriši logove",
    "back": "Nazad"
  },
  "settings": {
    "title": "Postavke",
    "discord": "Discord",
    "bank": "Banka (ASA)",
    "notifications": "Obavijesti",
    "channel": "Kanal",
    "payment": "Plaćanje",
    "configuredViaEnableDiscord": "Konfigurisano putem ENABLE_DISCORD",
    "configuredViaDiscordChannel": "Konfigurisano putem DISCORD_CHANNEL",
    "configuredViaPaymentEnabled": "Konfigurisano putem PAYMENT_ENABLED",
    "maskedValue": "••••••••"
  },
  "pagination": {
    "previous": "Prethodna",
    "next": "Sljedeća",
    "show": "Prikaži",
    "perPage": "po stranici",
    "range": "Prikazano {{start}}–{{end}} od {{total}}"
  },
  "error": {
    "failedToSave": "Čuvanje nije uspjelo",
    "failedToDelete": "Brisanje nije uspjelo",
    "failedToAssign": "Dodjela nije uspjela",
    "failedToRemove": "Uklanjanje nije uspjelo",
    "failedToUpdate": "Ažuriranje nije uspjelo",
    "failedToLoadPaymentHistory": "Učitavanje istorije plaćanja nije uspjelo",
    "registrationFailed": "Registracija nije uspjela",
    "loginFailed": "Prijava nije uspjela",
    "connectionFailed": "Povezivanje nije uspjelo",
    "noInvoicesToPay": "Nema računa za plaćanje",
    "paymentFailed": "Plaćanje nije uspjelo",
    "paymentCancelled": "Plaćanje je otkazano"
  },
  "app": {
    "title": "Platko",
    "logo": "Platko"
  },
  "language": {
    "english": "Engleski",
    "bosnian": "Bosanski"
  },
  "theme": {
    "switchToDark": "Prebaci na tamni način rada",
    "switchToLight": "Prebaci na svijetli način rada"
  },
  "confirm": {
    "deleteAddress": "Obrisati ovu adresu?"
  },
  "empty": {
    "noSpendingData": "Još nema podataka o troškovima",
    "noProviderData": "Još nema podataka o pružateljima",
    "noStatusData": "Još nema podataka o statusima",
    "noAddressData": "Još nema podataka o adresama",
    "chartsHint": "Pokrenite skupljanje da generišete podatke. Grafikoni se pojavljuju nakon prvog uvoza.",
    "noPaymentLogs": "Još nema logova plaćanja.",
    "noMessages": "Nema poruka za ovaj zadatak.",
    "waitingForLogs": "Čekanje na logove..."
  },
  "card": {
    "startScraping": "Pokreni skupljanje",
    "startScrapingDesc": "Pokreni skupljanje računa za sve adrese i pružatelje.",
    "viewLiveLogs": "Pregledaj logove uživo",
    "processPayments": "Obradi plaćanja",
    "processPaymentsDesc": "Pregledaj i obradi račune koji čekaju plaćanje.",
    "viewPendingInvoices": "Pregledaj račune koji čekaju plaćanje"
  },
  "table": {
    "invoiceDate": "Datum računa",
    "createdAt": "Kreirano",
    "address": "Adresa",
    "provider": "Pružatelj",
    "amount": "Iznos",
    "status": "Status",
    "actions": "Akcije",
    "name": "Naziv",
    "afterPayment": "Nakon plaćanja",
    "created": "Kreirano",
    "datePaid": "Plaćeno"
  },
  "detail": {
    "date": "Datum",
    "createdAt": "Kreirano",
    "amount": "Iznos",
    "status": "Status",
    "address": "Adresa",
    "provider": "Pružatelj",
    "reference": "Referenca",
    "account": "Račun",
    "datePaid": "Datum plaćanja",
    "age": "Starost",
    "taxDeduction": "Porezna stopa",
    "skipPayment": "Plaćanje"
  },
  "back": {
    "invoices": "Nazad na račune"
  },
  "logGroup": {
    "bankLogin": "Prijava na banku",
    "processingInvoice": "Obrada računa"
  },
  "paymentLog": {
    "simulated": "Simulirano",
    "invoices": "račune",
    "clickToViewLogs": "Klikni za pregled logova",
    "details": "Detalji loga plaćanja",
    "completed": "Završeno",
    "failed": "Neuspješno",
    "cancelled": "Otkazano",
    "running": "U toku",
    "messages": "Poruke",
    "entries": "Unosi"
  },
  "pageTitle": "Stranica",
  "saveError": "Čuvanje nije uspjelo",
  "deleteConfirm": "Obrisati ovo?",
  "deleteError": "Brisanje nije uspjelo",
  "startScraping": "Pokreni skupljanje",
  "startScrapingDesc": "Pokreni skupljanje računa za sve adrese i pružatelje.",
  "viewLiveLogs": "Pregledaj logove uživo",
  "processPayments": "Obradi plaćanja",
  "processPaymentsDesc": "Pregledaj i obradi račune koji čekaju plaćanje.",
  "viewPendingInvoices": "Pregledaj račune koji čekaju plaćanje",
  "confirmPay": "Potvrdi & Plati",
  "notSet": "Nije postavljeno"
}
